import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

let numeral = require('numeral')
numeral.nullFormat('')

export default () => {
  const data = useStaticQuery(query)
  const titre = data.allRsrlComptesXlsxAnnexe.edges[0].node.TITRE
  return (
    <div className="text-content accordion-content accordion-table">
      <table>
        <tbody>
          <tr>
            <th />
            <th align="right" />
            <th align="right" />
          </tr>
          {data.allRsrlComptesXlsxAnnexe.edges.map(({ node }) => (
            <tr key={node.id} className={node.CLASSE}>
              <td>{node.LABEL}</td>
            </tr>
          ))}
          <tr>
            <th />
            <th align="right">2025</th>
            <th align="right">2024</th>
          </tr>
          {data.allRsrlComptesXlsxAnnexe2.edges.map(({ node }) => (
            <tr key={node.id} className={node.CLASSE}>
              <td>{node.COMPTE}</td>
              <td align="right">
                {numeral(node.ANNEE || '')
                  .format('0.00')
                  .toString()
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'")}
              </td>
              <td align="right">
                {numeral(node.ANNEE_PRECEDENTE || '')
                  .format('0.00')
                  .toString()
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

const query = graphql`
  query {
    allRsrlComptesXlsxAnnexe {
      edges {
        node {
          id
          CLASSE
          LABEL
          TITRE
        }
      }
    }

    allRsrlComptesXlsxAnnexe2 {
      edges {
        node {
          id
          CLASSE
          COMPTE
          ANNEE
          ANNEE_PRECEDENTE
        }
      }
    }
  }
`
